interface RouteParams extends ng.route.IRouteParamsService {
  eventId: string;
}

class EventAnalyticsController {
  public eventId: string;
  public customerId: string;
  public auth: any;

  constructor(private $routeParams: RouteParams, private Authentication) {
    'ngInject';
    this.eventId = this.$routeParams.eventId;
    this.customerId = this.Authentication.getCurrentUser().customerID;
    this.auth = this.Authentication;
  }
}
module.exports = EventAnalyticsController;
